import { PAGE } from "#/constants";
import useWindowDimensions from "#/hooks/useWindowDimensions";
import { getWidth } from "#/utils/windowDimensionUtils";
import { Button, Icon, List, Paragraph, Spacing, Title } from "@sicredi/react";
import styles from "./styles.module.scss";

export default function FooterContainer() {
  const { width } = useWindowDimensions();

  const about = [
    {
      id: 0,
      label: "Quem somos",
      routerOrhref: "https://shopping.sicredi.com.br/sobre-nos",
    },
    {
      id: 1,
      label: "Nosso Shopping",
      routerOrhref: "https://shopping.sicredi.com.br/nosso-shopping",
    },
    {
      id: 2,
      label: "Seja associado",
      routerOrhref:
        "https://www.sicredi.com.br/site/seja-associado/?utm_source=SPD_sejassociado_menu_site&utm_medium=SPD_sejassociado_menu_site_associacoes&utm_campaign=SPD_sejassociado_menu&utm_id=SPD_sejassociado_menu&utm_term=SPD_sejassociado_menu2112",
    },
    {
      id: 3,

      label: "Trabalhe conosco",
      routerOrhref: "https://sicredi.gupy.io/",
    },
    {
      id: 4,
      label: "Sustentabilidade",
      routerOrhref:
        "https://www.sicredi.com.br/site/sobre-nos/sustentabilidade/",
    },
  ];

  const politics = [
    {
      id: 1,
      label: "Termos de uso",
      routerOrhref: "https://shopping.sicredi.com.br/termos-e-condicoes",
    },
    {
      id: 2,
      label: "Políticas de entrega",
      routerOrhref: "https://shopping.sicredi.com.br/politica-de-entrega",
    },
    {
      id: 3,
      label: "Política de privacidade",
      routerOrhref: "https://shopping.sicredi.com.br/politica-de-privacidade",
    },
  ];

  const help = [
    {
      id: 0,
      label: "Dúvidas frequentes",
      routerOrhref: PAGE.FAQ(),
    },
    {
      id: 1,
      label: "Segurança",
      routerOrhref: "https://www.sicredi.com.br/site/seguranca/",
    },
  ];

  const socialMedias = [
    {
      id: 0,
      img: "/icons/instagram-dark-green.svg",
      alt: "Instagram",
      link: "https://www.instagram.com/sicredi",
    },
    {
      id: 1,
      img: "/icons/facebook-dark-green.svg",
      alt: "Facebook",
      link: "https://www.facebook.com/Sicredi",
    },
    {
      id: 2,
      img: "/icons/linkedin-dark-green.svg",
      alt: "Linkedin",
      link: "https://www.linkedin.com/company/sicredi/",
    },
    {
      id: 3,
      img: "/icons/x-twitter-dark-green075.svg",
      alt: "Twitter",
      link: "https://twitter.com/sicredi",
      width: 24,
      height: 24,
    },
    {
      id: 4,
      img: "/icons/youtube-dark-green.svg",
      alt: "Youtube",
      link: "https://www.youtube.com/user/sicredioficial",
    },
  ];

  const paymentForms = [
    // { id: 0, img: "/icons/visa.svg", alt: "cartão visa" },
    // { id: 1, img: "/icons/master.svg", alt: "cartão mastercard" },
    { id: 2, img: "/icons/pix.svg", alt: "pix" },
  ];

  const paymentList = paymentForms.map((elem) => (
    <img
      data-testid={`footer-paymentForms${elem.id}`}
      key={elem.id}
      src={elem.img}
      alt={elem.alt}
      width={32}
      height={32}
      style={{
        margin: "1rem 12px  0 0",
        marginRight: "12px",
      }}
    />
  ));
  const politicsLinks = politics.map((elem) => (
    <a
      data-testid={`footer-politics${elem.id}`}
      key={elem.label}
      href={elem.routerOrhref}
    >
      <span>{elem.label}</span>
    </a>
  ));
  const helpLinks = help.map((elem) => (
    <a
      data-testid={`footer-help${elem.id}`}
      key={elem.label}
      href={elem.routerOrhref}
    >
      <span>{elem.label}</span>
    </a>
  ));
  const aboutLinks = about.map((elem) => (
    <a
      data-testid={`footer-about${elem.id}`}
      key={elem.label}
      href={elem.routerOrhref}
    >
      <span>{elem.label}</span>
    </a>
  ));
  const logo = (
    <div className={styles["logo-development"]}>
      <Paragraph size="small" weight="x-light">
        Desenvolvido por{" "}
      </Paragraph>
      <img
        width={112}
        height={14}
        src="/icons/startaideia.svg"
        alt="startaideia"
      />
    </div>
  );
  const socialMediasLinks = socialMedias.map((elem) => (
    <Button
      data-testid={`footer-socialMedias${elem.id}`}
      key={elem.id}
      className={styles["button-icon"]}
      onClick={() => window.open(elem.link)}
    >
      <img
        src={elem.img}
        alt={elem.alt}
        width={elem?.width ?? 32}
        height={elem?.height ?? 32}
      />
    </Button>
  ));

  return (
    <div data-testid="footer">
      {getWidth(width, 1024) ? (
        <div data-testid="footer-desktop">
          <div className="margin-line"></div>
          <div className={styles["footer"]}>
            <div className={styles.item}>
              <Title as="h5" weight="semi-bold">
                Sobre nós
              </Title>
              <Spacing appearance="medium" />

              {aboutLinks}
            </div>
            <div className={styles.item}>
              <Title as="h5" weight="semi-bold">
                Políticas
              </Title>
              <Spacing appearance="medium" />
              {politicsLinks}

              <Spacing appearance="large" />
              <Title as="h5" weight="semi-bold">
                Ajuda
              </Title>
              <Spacing appearance="medium" />
              {helpLinks}
            </div>
            <div className={styles.item}>
              <Title as="h5" weight="semi-bold" appearance="primary">
                <Icon name="phone" style={{ marginRight: "4px" }} />
                Serviços por telefone
              </Title>
              <Paragraph>
                de segunda a sábado das
                <br />
                08h às 20h40 (Exceto feriados)
              </Paragraph>
              <Spacing appearance="small" />
              <a className={styles.green} href="tel: 0800 724 4770">
                <span>0800 724 4770</span>
              </a>
              <Spacing appearance="small" />
              <Title as="h5" weight="semi-bold" appearance="primary">
                Ouvidoria
              </Title>
              <Paragraph>Reclamações e denúncias</Paragraph>
              <a className={styles.green} href="tel: 0800 646 2519">
                <span>0800 646 2519</span>
              </a>
              <Spacing appearance="small" />
              <Title as="h5" weight="semi-bold" appearance="primary">
                Atendimento a pessoas com deficiência
              </Title>
              <Paragraph>Auditivo ou de fala</Paragraph>
              <a className={styles.green} href="tel: 0800 724 0525">
                <span>0800 724 0525</span>
              </a>
            </div>
            <div className={styles.item}>
              <Title as="h5" weight="semi-bold" appearance="primary">
                <Icon name="sac" style={{ marginRight: "4px" }} />
                SAC
              </Title>
              <Paragraph>
                Informações, elogios e reclamações
                <a
                  className={styles.green}
                  style={{ margin: "2px 0" }}
                  href="tel: 0800 724 7220"
                >
                  <span>0800 724 7220</span>
                </a>
              </Paragraph>
              <Spacing appearance="small" />
              <Title as="h5" weight="semi-bold">
                Nossas Redes Sociais
              </Title>
              {socialMediasLinks}

              <Spacing appearance="xx-large" />
              <div className={styles.item}>
                <Title as="h5" weight="semi-bold">
                  Formas de Pagamento
                </Title>
                {paymentList}
                <Paragraph>
                  *É vedada a cobrança de preço superior, valor ou encargo{" "}
                  <br /> adicional para pagamentos por meio de Pix à vista.
                  <br /> *Em breve pontos dos Cartões Sicredi
                </Paragraph>
              </div>
            </div>
          </div>
          {logo}
        </div>
      ) : (
        <div className={styles["footer"]} data-testid="footer-mobile">
          <div className={styles.item}>
            <Title as="h5" weight="semi-bold" appearance="primary">
              <Icon name="phone" style={{ marginRight: "4px" }} />
              Serviços por telefone
            </Title>
            <Paragraph>
              de segunda a sábado das
              <br />
              08h às 20h40 (Exceto feriados)
            </Paragraph>
            <Spacing appearance="small" />
            <a className={styles.green} href="tel: 0800 724 4770">
              <span>0800 724 4770</span>
            </a>
            <Spacing appearance="small" />
            <Title as="h5" weight="semi-bold" appearance="primary">
              Ouvidoria
            </Title>
            <Paragraph>Reclamações e denúncias</Paragraph>
            <a className={styles.green} href="tel: 0800 646 2519">
              <span>0800 646 2519</span>
            </a>
            <Spacing appearance="small" />
            <Title as="h5" weight="semi-bold" appearance="primary">
              Atendimento a pessoas com deficiência
            </Title>
            <Paragraph>Auditivo ou de fala</Paragraph>
            <a className={styles.green} href="tel: 0800 724 0525">
              <span>0800 724 0525</span>
            </a>

            <Spacing appearance="small" />
            <Title as="h5" weight="semi-bold">
              Nossas Redes Sociais
            </Title>
            {socialMediasLinks}
          </div>

          {/* <div className={styles.item}> */}
          {/* list */}
          <Spacing appearance="xx-large" />
          <List
            id="mobile-list"
            aria-label=""
            className={styles["mobile-list"]}
            // onChange={(e) => console.log(e)}
          >
            <List.Item
              label="Nossas Parcerias e Descontos"
              data-testid="item1"
              // onClick={() => setAboutUsList(!aboutUsList)}
            >
              {aboutLinks}
            </List.Item>
            <List.Item
              label="Políticas"
              data-testid="item2"
              // onClick={() => setPoliticsList(!politicsList)}
            >
              {politics.map((elem) => (
                <a
                  data-testid={`footer-mobile-politics${elem.id}`}
                  key={elem.label}
                  href={elem.routerOrhref}
                >
                  <span>{elem.label}</span>
                </a>
              ))}
            </List.Item>
            <List.Item
              label="Ajuda"
              data-testid="item3"
              // onClick={() => setHelpList(!helpList)}
            >
              {helpLinks}
            </List.Item>
          </List>
          {/* </div> */}
          {/* <div style={{ margin: "0 1rem" }}>
            <Spacing appearance="small" />
            <Title as="h5" weight="semi-bold">
              Formas de Pagamento
            </Title>
            <div>{paymentList}</div>
          </div> */}
          {logo}
        </div>
      )}
    </div>
  );
}
